import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import AppStore from '../../../stores/AppStore'
import { SimpleLink } from '../Navigation/Buttons'
import { DeviceTypeName } from '../SettingPageComponents/DeviceType'
import styles from '../../../../css/devicePage.module.css'

const copyToClipboard = (text) => {
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text)
  }
  return Promise.resolve(false)
}

const PhysicalButtons = function PhysicalButtons ({
  device,
  path,
  physicalTypes,
  intl,
}) {
  const level = AppStore.getUser()?.permissions?.level || 0

  const {
    formatMessage,
  } = intl

  const {
    group_id: groupID,
    is_active: isActive,
    physical,
    address_alias: addressAlias,
    configuration,
  } = device

  const { model } = configuration || {}

  if (!physicalTypes || physicalTypes.length < 1) {
    return (
      <section />
    )
  }
  const physicalReturn = []

  const userStyle = styles.simpleLinkStandalone

  const YES = formatMessage({
    id: 'general.yes',
    defaultMessage: 'Yes',
    description: 'Yes',
  })

  const NO = formatMessage({
    id: 'general.no',
    defaultMessage: 'No',
    description: 'No',
  })

  for (let i = 0; i < physicalTypes.length; i += 1) {
    let physicalTemporary

    switch (physicalTypes[i]) {
      case 'deviceType':
        physicalTemporary = (
          <SimpleLink
            key={`/${path}deviceType`}
            userStyle={userStyle}
            path={`${path}deviceType`}
            label={formatMessage({
              id: 'device.type',
              defaultMessage: 'Device Type',
              description: 'Device Type',
            })}
            value={DeviceTypeName(physical.deviceType)}
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'deviceNumber':
        physicalTemporary = (
          <SimpleLink
            key={`${path}deviceNumber`}
            userStyle={userStyle}
            path={`${path}deviceNumber`}
            label={formatMessage({
              id: 'device.name',
              defaultMessage: 'Device Name',
              description: 'Device Name',
            })}
            value={physical.deviceNumber}
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'deviceGroup': {
        let value
        if (typeof AppStore.getCustomer() === 'object') {
          const { applications } = AppStore.getCustomer()
          if (Array.isArray(applications) && applications.length > 0) {
            const group = applications.find(item => item.groupID === groupID)
            const { name } = group || {}
            value = name
          }
        }
        physicalTemporary = (
          <SimpleLink
            key={`${path}deviceGroup`}
            userStyle={userStyle}
            path={`${path}deviceGroup`}
            label={formatMessage({
              id: 'device.group',
              defaultMessage: 'Device Group',
              description: 'Device Group',
            })}
            value={value}
            unit=''
            enable={level >= 10}
          />
        )
        break
      }

      case 'isActive': {
        physicalTemporary = (
          <SimpleLink
            key={`${path}isActive`}
            userStyle={userStyle}
            path={`${path}isActive`}
            label={formatMessage({
              id: 'device.isActive',
              defaultMessage: 'Device Status',
              description: 'Device Status',
            })}
            value={isActive ? 'Active' : 'Inactive'}
            unit=''
            enable={level >= 20}
          />
        )
        break
      }

      case 'rpmMultiplier':
        physicalTemporary = (
          <SimpleLink
            key={`${path}rpmMultiplier`}
            userStyle={userStyle}
            path={`${path}rpmMultiplier`}
            label={formatMessage({
              id: 'setting.rpm.multiplier',
              defaultMessage: 'Speed Multiplier',
              description: 'Speed Multiplier',
            })}
            value={Math.round((1 / physical.rpmMultiplier) * 100) / 100}
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'fuelTankSize':
        physicalTemporary = (
          <SimpleLink
            key={`${path}fuelTankSize`}
            userStyle={userStyle}
            path={`${path}fuelTankSize`}
            label={formatMessage({
              id: 'setting.fuel.tankSize',
              defaultMessage: 'Fuel Tank Size',
              description: 'Fuel Tank Size',
            })}
            value={physical.fuelTankSize}
            unit='ft'
            enable={level >= 10}
          />
        )
        break

      case 'fuelSensorRange':
        physicalTemporary = (
          <SimpleLink
            key={`${path}fuelSensorRange`}
            userStyle={userStyle}
            path={`${path}fuelSensorRange`}
            label={formatMessage({
              id: 'setting.fuel.sensorRange',
              defaultMessage: 'Fuel Sensor Range',
              description: 'Fuel Sensor Range',
            })}
            value={physical.fuelSensorRange}
            unit='ft'
            enable={level >= 10}
          />
        )
        break

      case 'offRpm':
        physicalTemporary = (
          <SimpleLink
            key={`${path}offRpm`}
            userStyle={userStyle}
            path={`${path}offRpm`}
            label={formatMessage({
              id: 'setting.rpm.off',
              defaultMessage: 'Off Speed',
              description: 'Off Speed',
            })}
            value={physical.offRpm}
            unit='Speed'
            enable={level >= 10}
          />
        )
        break

      case 'highRpm':
        physicalTemporary = (
          <SimpleLink
            key={`${path}highRpm`}
            userStyle={userStyle}
            path={`${path}highRpm`}
            label={formatMessage({
              id: 'setting.rpm.high',
              defaultMessage: 'High Speed',
              description: 'High Speed',
            })}
            value={physical.highRpm}
            unit='Speed'
            enable={level >= 10}
          />
        )
        break

      case 'powered':
        physicalTemporary = (
          <SimpleLink
            key={`${path}powered`}
            userStyle={userStyle}
            path={`${path}powered`}
            label={formatMessage({
              id: 'setting.powered',
              defaultMessage: 'Powered',
              description: 'Powered',
            })}
            value={physical.powered ? YES : NO}
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'debounce':
        physicalTemporary = (
          <SimpleLink
            key={`${path}debounce`}
            userStyle={userStyle}
            path={`${path}debounce`}
            label={formatMessage({
              id: 'setting.debounce',
              defaultMessage: 'Debounce',
              description: 'Debounce',
            })}
            value={physical.debounce ? YES : NO}
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'voltageScale':
        physicalTemporary = (
          <SimpleLink
            key={`${path}voltageScale`}
            userStyle={userStyle}
            path={`${path}voltageScale`}
            label={formatMessage({
              id: 'setting.voltageScale',
              defaultMessage: 'Input Scale',
              description: 'Input Scale',
            })}
            value='Click to Set'
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'fourToTwentySD1':
        physicalTemporary = (
          <SimpleLink
            key={`${path}fourToTwentySD1`}
            userStyle={userStyle}
            path={`${path}fourToTwentySD1`}
            label={formatMessage({
              id: 'setting.fourToTwentySD1',
              defaultMessage: 'SD Input 1 Scale',
              description: 'SD Input 1 Scale',
            })}
            value='Click to Set'
            unit=''
            enable={level >= 10}
          />
        )
        break
      case 'fourToTwentySD2':
        physicalTemporary = (
          <SimpleLink
            key={`${path}fourToTwentySD2`}
            userStyle={userStyle}
            path={`${path}fourToTwentySD2`}
            label={formatMessage({
              id: 'setting.fourToTwentySD2',
              defaultMessage: 'SD Input 2 Scale',
              description: 'SD Input 2 Scale',
            })}
            value='Click to Set'
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'powerPort':
        physicalTemporary = (
          <SimpleLink
            key={`${path}powerPort`}
            userStyle={userStyle}
            path={`${path}powerPort`}
            label={formatMessage({
              id: 'setting.powerPort',
              defaultMessage: 'Power Port',
              description: 'Power Port',
            })}
            value={physical.powerPort}
            unit=''
            enable={level >= 10}
          />
        )
        break

      case 'moistureSensor':
        physicalTemporary = (
          <SimpleLink
            key={`${path}moistureSensor`}
            userStyle={userStyle}
            path={`${path}moistureSensor`}
            label={formatMessage({
              id: 'setting.moistureSensor',
              defaultMessage: 'Moisture Sensor',
              description: 'Moisture Sensor',
            })}
            value={physical.moistureSensor}
            unit=''
            enable={level >= 10}
          />
        )
        break

      default:
        break
    }
    physicalReturn.push(physicalTemporary)
  }

  physicalReturn.push(
    <section key={`${path}address_alias`} className={userStyle}>
      <h5>
        {formatMessage({
          id: 'device.alias',
          defaultMessage: 'Altrac Alias',
          description: 'Altrac Alias',
        })}
      </h5>
      <div className={styles.aliasValueRow}>
        <div className={styles.simpleLinkValue}>
          {addressAlias}
        </div>
        {addressAlias && (
          <button
            type='button'
            className={styles.copyAliasButton}
            onClick={(e) => {
              e.preventDefault()
              copyToClipboard(addressAlias)
            }}
            title={formatMessage({
              id: 'support.api.copy',
              defaultMessage: 'Copy',
              description: 'Copy to clipboard',
            })}
            aria-label={formatMessage({
              id: 'support.api.copy',
              defaultMessage: 'Copy',
              description: 'Copy to clipboard',
            })}
          >
            <i className='fa fa-copy fa-lg' aria-hidden='true' />
          </button>
        )}
      </div>
    </section>
  )

  if (model) {
    physicalReturn.push(
      <SimpleLink
        key={`${path}model_number`}
        userStyle={userStyle}
        path={`${path}model_number`}
        label={formatMessage({
          id: 'device.configuration.model',
          defaultMessage: 'Model Number',
          description: 'Model Number',
        })}
        value={model}
        unit=''
        enable={false}
      />
    )
  }

  return (
    <section>
      <div className={styles.physical}>
        <ul>
          {physicalReturn}
        </ul>
      </div>
    </section>
  )
}

PhysicalButtons.propTypes = {
  physicalTypes: PropTypes.array,
  path: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
}

export default injectIntl(PhysicalButtons)
